// 날짜 표현 수정 (TestCalender에서 복사)
export const formatDateToYYMMDD = (date) => {
    const yy = String(date.getFullYear()).slice(-2);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yy}.${mm}.${dd}`;
};

// 요일 노출 (TestCalender에서 복사)
export const getDayKoreanLetter = (date) => {
    const days = ['일', '월', '화', '수', '목', '금', '토'];
    return days[date.getDay()];
};